import { ActivitySearchItemProps } from "@/app/activity/list/type"
import { format } from "date-fns"
import { useMemo } from "react"
import { getActivityColor } from "@/app/activity/list/utils"
import Icon from "@/components/icon/Icon"

import "./activitySearchItem.scss"
import { HOUR_TO_SECOND_FORMAT, YEAR_TO_DAY_FORMAT } from "@/constants/regex"

export default function ActivitySearchItem({
  dateFinish,
  dateStart,
  name,
  onClick,
  ...activity
}: ActivitySearchItemProps) {
  const duration = useMemo(() => {
    const date = format(dateStart, YEAR_TO_DAY_FORMAT)
    const startTime = format(dateStart, HOUR_TO_SECOND_FORMAT)
    const endTime = format(dateFinish, HOUR_TO_SECOND_FORMAT)

    return { date, duration: `${startTime} ~ ${endTime}` }
  }, [dateFinish, dateStart])

  return (
    <div
      className="ActivitySearchItemCont"
      onClick={() => onClick({ ...activity, dateFinish, dateStart, name })}>
      <div className="activity-icon-type">
        <Icon
          className="activity-type-ico"
          type="circle-fill"
          color={getActivityColor(activity.type)}
        />
        <p className="activity-search-item-title">{name}</p>
      </div>
      <div className="activity-search-item-description">
        <p>{duration.date}</p>
        <p>{duration.duration}</p>
      </div>
    </div>
  )
}
